export default __webpack_public_path__ + "static/media/discordDeskMobile.05fd3d1a.svg";